import { createFileRoute } from '@tanstack/react-router';
import { CampaignFormSubmissionsRouteView } from '@/pages/workspaces/automations/[campaignId]/form-submissions/routing';

function CampaignFormSubmissionsRoute() {
  const { campaignId } = Route.useParams();
  return <CampaignFormSubmissionsRouteView campaignId={campaignId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/form-submissions',
)({
  component: CampaignFormSubmissionsRoute,
});
